import { Link } from 'react-router-dom';
import './DealCard.css';

const EMOJI = {
  restaurants: '🍽', 'health-spa': '💆', fitness: '🏋', retail: '🛍',
  'home-services': '🔧', 'dental-medical': '🦷', education: '📚',
  auto: '🚗', entertainment: '🎭', beauty: '💇',
};

const daysLeft = (d) => {
  const diff = Math.ceil((new Date(d) - new Date()) / 86400000);
  if (diff <= 0) return 'Expired';
  if (diff === 1) return 'Last day!';
  if (diff <= 3) return `${diff} days left`;
  return `${diff} days`;
};

export default function DealCard({ deal }) {
  const urgent = daysLeft(deal.valid_until) === 'Last day!' || daysLeft(deal.valid_until).includes('2 days') || daysLeft(deal.valid_until).includes('1 days');

  return (
    <Link to={`/deals/${deal.id}`} className="deal-card fade-up">
      {deal.is_featured && <div className="deal-featured-ribbon">Featured</div>}
      <div className="deal-card-img">
        {deal.image_url
          ? <img src={deal.image_url} alt={deal.title} />
          : <span className="deal-card-emoji">{EMOJI[deal.category] || '🏷'}</span>
        }
        <span className="deal-discount-badge">{deal.discount_percent}% off</span>
      </div>
      <div className="deal-card-body">
        <div className="deal-biz-name">{deal.business_name}</div>
        <h3 className="deal-title">{deal.title}</h3>
        <div className="deal-price-row">
          <span className="deal-price">${Number(deal.deal_price).toFixed(2)}</span>
          <span className="deal-orig">${Number(deal.original_price).toFixed(2)}</span>
        </div>
        <div className="deal-card-footer">
          <span className="deal-neighbourhood">{deal.neighbourhood || 'Winnipeg'}</span>
          <span className={`deal-expiry ${urgent ? 'urgent' : ''}`}>
            {daysLeft(deal.valid_until)}
          </span>
        </div>
      </div>
    </Link>
  );
}
